import React, {useEffect, useState} from "react";
import Keyboard from "./Keyboard";
import {useSelector} from "react-redux";

function useLastInput() {
    const [lastInput, setLastInput] = useState(null);

    useEffect(() => {
        const handler = (e) => {
            const el = e.target;
            if (
                el.tagName === "INPUT" ||
                el.tagName === "TEXTAREA" ||
                el.isContentEditable
            ) {
                setLastInput(el);
            }
        };

        document.addEventListener("focusin", handler);
        return () => document.removeEventListener("focusin", handler);
    }, []);

    return lastInput;
}

export default () => {
    const keyboard = useSelector(state => state.rootReducer.keyboard);
    let [layout, setLayout] = useState("letters");
    const activeEl = useLastInput();

    useEffect(() => {
        if(activeEl !== null){
            let elLayout = activeEl.getAttribute("data-keyboard-layout");
            if(elLayout !== null){
                setLayout(elLayout);
            }
        }
    }, [activeEl]);

    if(!keyboard.show){
        return <></>;
    }

    return <div style={{
        "position": "absolute",
        "bottom": 0,
        "left": 0,
        "right": 0,
        "zIndex": 100
    }}>
        <Keyboard options={{
            layout,
            onChangeToNumbers: () => {
                setLayout("numbers");
                activeEl.focus();
            },
            onChangeToLetters: () => {
                setLayout("letters");
                activeEl.focus();
            },
            onClick: (key) => {
                const setter = Object.getOwnPropertyDescriptor(
                    HTMLInputElement.prototype,
                    "value"
                ).set;
                setter.call(activeEl, key === 'delete' ? activeEl.value.slice(0, -1) : activeEl.value + key);
                activeEl.dispatchEvent(new Event('input', {bubbles: true}));
                activeEl.focus();
            },
            onDone: keyboard.onDone
        }}/>
    </div>
}